import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/ElearningLogDetails/api/elearningLogDetailsService'
import { ElearningLogDetailsState, ApiElearningLogDetailsResponse } from './types'

const initialState: ElearningLogDetailsState = {
  data: {},
}

const elearningLogDetailsSlice = createSlice({
  name: 'activityLogElearningLogDetails',
  initialState,
  reducers: {
    dataLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiElearningLogDetailsResponse>>) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = elearningLogDetailsSlice.actions

export default elearningLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
